var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "s-orders-page"
  }, [_c('div', {
    staticClass: "s-orders-nav"
  }, [_c('span', {
    staticClass: "s-flex-basis-25 pl-3",
    on: {
      "click": _vm.backToIndex
    }
  }, [_c('BIconChevronLeft', {
    attrs: {
      "font-scale": "1.2"
    }
  })], 1), _c('div', {
    staticClass: "text-center s-flex-basis-50"
  }, [_vm._v("訂單明細")])]), _vm.fetching ? [_c('Loading')] : void 0, _vm.order ? _c('div', {
    staticClass: "p-2 d-flex justify-content-around s-order-detail"
  }, [_c('div', {
    staticClass: "mt-2"
  }, [_c('p', {
    staticClass: "s-text-gray-darker s-whitespace-nowrap"
  }, [_vm._v(" 訂購日 : "), _c('span', [_vm._v(_vm._s(_vm.createdDateTime))])]), _c('p', {
    staticClass: "s-text-gray-darker s-whitespace-nowrap"
  }, [_vm._v(" 訂單號 : "), _c('span', [_vm._v(_vm._s(_vm.order.outer_order_number))])]), _c('p', {
    staticClass: "s-whitespace-nowrap s-flex-basis-50 s-text-gray-darker"
  }, [_vm._v(" " + _vm._s(_vm.deliveryText) + " ")]), _c('p', {
    staticClass: "s-font-bold s-orders-flex-line s-flex-basis-50 text-right"
  }, [_c('span', {
    staticClass: "s-text-gray-darker s-mr-2"
  }, [_vm._v("共 " + _vm._s(_vm.quantity) + " 件")]), _c('span', {
    staticClass: "s-text-secondary"
  }, [_vm._v(_vm._s(_vm.$currency(_vm.order.total)))])])]), _c('div', {
    staticClass: "d-flex flex-column justify-content-center s-space-y-4"
  }, [_vm.status === 'processing' && _vm.order.source_type === 3 ? _c('button', {
    staticClass: "s-orders-btn s-orders-btn--secondary",
    on: {
      "click": function click($event) {
        $event.preventDefault();
        return _vm.$refs.confirm.open();
      }
    }
  }, [_vm._v(" 取消訂單 ")]) : _vm._e(), _vm.status === 'processing' && (_vm.order.source_type === 1 || _vm.order.source_type === 2) && _vm.order.status === 'WaitingToShipping' ? _c('button', {
    staticClass: "s-orders-btn s-orders-btn--secondary",
    on: {
      "click": function click($event) {
        return _vm.redirectToPoyaReturnUrl();
      }
    }
  }, [_vm._v(" 取消訂單 ")]) : _vm._e(), _vm.status === 'processing' && _vm.order.source_type === 3 ? _c('button', {
    staticClass: "s-orders-btn",
    on: {
      "click": function click($event) {
        return _vm.route.push({
          name: 'LiffOrderEdit'
        });
      }
    }
  }, [_vm._v(" 修改數量 ")]) : _vm._e()])]) : _vm._e(), _vm.order.items.length ? [_c('ul', {
    staticClass: "s-mb-6"
  }, _vm._l(_vm.order.items, function (item, i) {
    return _c('li', {
      key: i
    }, [_c('div', {
      staticClass: "s-order-item align-items-center"
    }, [_c('div', {
      staticClass: "s-order-item-image"
    }, [_c('div', {
      staticClass: "s-order-item-image-wrapper"
    }, [_c('img', {
      attrs: {
        "src": _vm.image(item)
      }
    })])]), _c('div', {
      staticClass: "s-order-item-info s-space-y-2 s-text-sm s-text-gray-darker"
    }, [_c('p', {}, [_vm._v(_vm._s(item.title))]), _c('p', {
      staticClass: "s-whitespace-nowrap"
    }, [_vm._v(" " + _vm._s(item.outer_order_item_number) + " ")]), _c('p', [_vm._v(_vm._s(item.quantity) + " 件 " + _vm._s(_vm.$currency(item.total_price)))])])])]);
  }), 0)] : _vm._e(), _c('Modal', {
    ref: "confirm",
    attrs: {
      "title": "您是否要取消訂單？"
    },
    scopedSlots: _vm._u([{
      key: "actions",
      fn: function fn(_ref) {
        var close = _ref.close;
        return [_c('div', {
          staticClass: "s-flex s-space-x-3"
        }, [_c('button', {
          staticClass: "s-btn s-btn-secondary",
          attrs: {
            "type": "button"
          },
          on: {
            "click": _vm.cancelOrder
          }
        }, [_vm._v(" 取消訂單 ")]), _c('button', {
          staticClass: "s-btn s-btn-primary",
          attrs: {
            "type": "button"
          },
          on: {
            "click": close
          }
        }, [_vm._v(" 保留訂單 ")])])];
      }
    }])
  }, [_vm._v(" 您是否要取消訂單？ ")])], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }